import { createTransport } from "./transportFactory.js";

const { transport, baseUrl } = createTransport("codeReviewer");

export const codeReviewerTransport = transport;
export const CODE_REVIEWER_BASE_URL = baseUrl;
